import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { UpdatePlaylistFolderDocument } from './update.generated';

export const useUpdatePlaylistFolder = (
  options: ApiOptions<typeof UpdatePlaylistFolderDocument> = {},
) => {
  const { t } = useTranslation();

  return useMutation(UpdatePlaylistFolderDocument, {
    ...useNotifications(UpdatePlaylistFolderDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.playlist_folders.update_success'),
    }),
    ...options,
  });
};
